import { useFiles } from 'client/store'
import filesSelectors from 'client/store/files/filesSelectors'
import { usePage } from 'client/store/index'
import { pageSelectors } from 'client/store/page/pageSelectors'
import {
  createFontFace,
  entitiesWithFontOptions,
  getGlobalSettingsCustomFontProperties,
} from 'common/utils/fontsUtils'
import { useEffect } from 'react'
import { DataFilesDto } from 'src/server/dto/data-file.dto'
import { PageEntityInterface } from 'src/shared/types/base-entity-interface'
import { CustomFontsGenerator } from 'src/shared/utils/custom-fonts-generator'

function useCustomFontFaces() {
  const generator = new CustomFontsGenerator()

  const globalFontProperties = usePage(page =>
    pageSelectors.getGlobalFontProperties(page),
  )

  const entities = usePage(page =>
    pageSelectors.getEntitiesByTypes(page, entitiesWithFontOptions),
  )

  const files = useFiles(files => filesSelectors.getAllFiles(files))

  const globalSettingsFonts =
    getGlobalSettingsCustomFontProperties(globalFontProperties)

  useEffect(() => {
    const fontFaces = generator.generate(
      entities as PageEntityInterface[],
      Object.values(files) as DataFilesDto,
      globalSettingsFonts,
    )

    document.head.appendChild(createFontFace(fontFaces))
  }, [files])
}

export default useCustomFontFaces
